import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducers';

export enum CurrentState {
  gettingReady = 'gettingReady',
  selecting = 'selecting',
  nothingAvailable = 'nothingAvailable',
}

export enum SelectingState {
  simple = 'simple',
  allAvailable = 'allAvailable',
  allExisting = 'allExisting',
}

export type Item = { id: string, [key: string]: any };

export interface State {
  available: Item[];
  selected: Item[];
  search: string;
  page: number;
  current: CurrentState;
  selectingState: SelectingState;
  totalCount: number;
}

export const initialState: State = {
  available: [],
  selected: [],
  search: '',
  page: 1,
  current: CurrentState.gettingReady,
  selectingState: SelectingState.simple,
  totalCount: 0,
};

const menuListSlice = createSlice({
  name: 'menuList',
  initialState,
  reducers,
});

export function hasSelectedAll(state: State) {
  return state.selected.length === state.available.length;
}

export const {
  updateTotalCount,
  setAvailable,
  addAvailable,
  toggleItem,
  toggleAll,
  reset,
  cancelAllExisting,
  updateSearch,
  nextPage,
  prevPage,
  setPage,
  selectAllExisting,
} = menuListSlice.actions;

export default menuListSlice.reducer;
